import { type PermissionRouteData, PermissionRoute } from '@exam-management/permission-route';
import { APP_PERMISSIONS } from '@exam-management/permissions';

export default function TaskManagementRouteController() {
  const defaultRoutes: PermissionRouteData[] = [
    {
      path: '/task-management/question-creation',
      requiredPermission: [APP_PERMISSIONS.TASK.QUESTION_CREATION.VIEW],
    },
    {
      path: '/task-management/question-review',
      requiredPermission: [APP_PERMISSIONS.TASK.QUESTION_REVIEW.VIEW],
    },
    {
      path: '/task-management/qset-review',
      requiredPermission: [APP_PERMISSIONS.TASK.QSET_REVIEW.VIEW],
    },
  ];

  return <PermissionRoute routes={defaultRoutes} />;
}
